<template>
  <div>
    <b-row>
      <b-col
        v-for="(fileconf, index) in withModelFilesConfig"
        :key="index"
        class="pb-3 pt-3"
        cols="12"
        lg="6"
      >
        <b-row>
          <b-col cols="12" lg="4" class="align-middle">
            <label :for="fileconf.file_attr">{{ fileconf.label }}</label>
          </b-col>
          <b-col cols="1" lg="1">
            <a :href="fileconf.model" target="_blank">
              <font-awesome-icon icon="download" class="download-icon" />
            </a>
          </b-col>
          <b-col cols="11" lg="7">
            <div v-if="upload_progress[fileconf.file_attr] > -1">
              <b-progress
                :value="upload_progress[fileconf.file_attr]"
                variant="info"
                striped
                animated
                class="mb-2"
              >
              </b-progress>
            </div>
            <div v-if="uploadedFilesByFileAttr[fileconf.file_attr]">
              <b-row>
                <b-col>
                  <b-link
                    :href="uploadedFilesByFileAttr[fileconf.file_attr].file"
                    class="font-italic font-weight-bold"
                    target="_blank"
                  >
                    {{ $t("importmedicinesform_files.download_file_link") }}
                  </b-link>
                </b-col>
                <b-col>
                  <b-button
                    variant="danger"
                    @click="
                      deleteDocument(
                        uploadedFilesByFileAttr[fileconf.file_attr].uuid
                      )
                    "
                  >
                    <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                    {{ $t("importmedicinesform_files.remove_file") }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-form-file
              :id="fileconf.file_attr"
              v-if="
                upload_progress[fileconf.file_attr] < 0 &&
                  !uploadedFilesByFileAttr[fileconf.file_attr]
              "
              v-model="form[fileconf.file_attr]"
              v-on:input="onFileInput($event, fileconf.file_attr)"
              required
              :state="form_state[fileconf.file_attr]"
              placeholder=""
              :browse-text="$t('importmedicinesform_files.browse_text')"
            >
            </b-form-file>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
export default {
  name: "import-medicines-form-files",
  props: {
    international_trade_config: Object,
    documentation: Object,
  },
  data() {
    return {
      form: {
        file_power_letter: undefined,
        file_informed_consent: undefined,
        file_conflict_of_interests: undefined,
        file_product_details: undefined,
        file_sworn_declaration: undefined,
        file_compliance_institution: undefined,
        file_import_authorization_request: undefined,
        file_recipe: undefined,
        file_treatment: undefined,
        file_identification: undefined,
        file_doctor_cv: undefined,
      },
      form_state: {
        file_power_letter: null,
        file_informed_consent: null,
        file_conflict_of_interests: null,
        file_product_details: null,
        file_sworn_declaration: null,
        file_compliance_institution: null,
        file_import_authorization_request: null,
        file_recipe: null,
        file_treatment: null,
        file_identification: null,
        file_doctor_cv: null,
      },
      form_invalid_feedback: {
        file_power_letter: undefined,
        file_informed_consent: undefined,
        file_conflict_of_interests: undefined,
        file_product_details: undefined,
        file_sworn_declaration: undefined,
        file_compliance_institution: undefined,
        file_import_authorization_request: undefined,
        file_recipe: undefined,
        file_treatment: undefined,
        file_identification: undefined,
        file_doctor_cv: undefined,
      },
      upload_progress: {
        file_power_letter: -1,
        file_informed_consent: -1,
        file_conflict_of_interests: -1,
        file_product_details: -1,
        file_sworn_declaration: -1,
        file_compliance_institution: -1,
        file_import_authorization_request: -1,
        file_recipe: -1,
        file_treatment: -1,
        file_identification: -1,
        file_doctor_cv: -1,
      },
      file_type: {
        file_power_letter: 15,
        file_informed_consent: 16,
        file_conflict_of_interests: 17,
        file_product_details: 18,
        file_sworn_declaration: 19,
        file_compliance_institution: 20,
        file_import_authorization_request: 21,
        file_recipe: 22,
        file_treatment: 23,
        file_identification: 24,
        file_doctor_cv: 25,
      },
      inverse_file_type: {
        "15": "file_power_letter",
        "16": "file_informed_consent",
        "17": "file_conflict_of_interests",
        "18": "file_product_details",
        "19": "file_sworn_declaration",
        "20": "file_compliance_institution",
        "21": "file_import_authorization_request",
        "22": "file_recipe",
        "23": "file_treatment",
        "24": "file_identification",
        "25": "file_doctor_cv",
      },
    };
  },
  computed: {
    ...mapState({
      importation_uploaded_files: state =>
        state.drugtransaction.importation_uploaded_files,
    }),
    uploadedFilesByFileAttr() {
      var documents = [];
      this.importation_uploaded_files.forEach(element => {
        let file_attr = this.inverse_file_type[String(element.file_type)];
        documents[file_attr] = Object.assign({}, element);
      });
      return documents;
    },
    withModelFilesConfig() {
      let conf = [];
      this.international_trade_config.active_file_power_letter &&
        conf.push({
          file_attr: "file_power_letter",
          file_type: 15,
          model: this.international_trade_config.file_power_letter,
          label: this.international_trade_config.name_file_power_letter,
        });

      this.international_trade_config.active_file_informed_consent &&
        conf.push({
          file_attr: "file_informed_consent",
          file_type: 16,
          model: this.international_trade_config.file_informed_consent,
          label: this.international_trade_config.name_file_informed_consent,
        });

      this.international_trade_config.active_file_conflict_of_interests &&
        conf.push({
          file_attr: "file_conflict_of_interests",
          file_type: 17,
          model: this.international_trade_config.file_conflict_of_interests,
          label: this.international_trade_config
            .name_file_conflict_of_interests,
        });

      this.international_trade_config.active_file_product_details &&
        conf.push({
          file_attr: "file_product_details",
          file_type: 18,
          model: this.international_trade_config.file_product_details,
          label: this.international_trade_config.name_file_product_details,
        });

      this.international_trade_config.active_file_sworn_declaration &&
        conf.push({
          file_attr: "file_sworn_declaration",
          file_type: 19,
          model: this.international_trade_config.file_sworn_declaration,
          label: this.international_trade_config.name_file_sworn_declaration,
        });

      this.international_trade_config.active_file_compliance_institution &&
        conf.push({
          file_attr: "file_compliance_institution",
          file_type: 20,
          model: this.international_trade_config.file_compliance_institution,
          label: this.international_trade_config
            .name_file_compliance_institution,
        });

      this.international_trade_config
        .active_file_import_authorization_request &&
        conf.push({
          file_attr: "file_import_authorization_request",
          file_type: 21,
          model: this.international_trade_config
            .file_import_authorization_request,
          label: this.international_trade_config
            .name_file_import_authorization_request,
        });

      this.international_trade_config.active_file_recipe &&
        conf.push({
          file_attr: "file_recipe",
          file_type: 22,
          model: this.international_trade_config.file_recipe,
          label: this.international_trade_config.name_file_recipe,
        });

      this.international_trade_config.active_file_treatment &&
        conf.push({
          file_attr: "file_treatment",
          file_type: 23,
          model: this.international_trade_config.file_treatment,
          label: this.international_trade_config.name_file_treatment,
        });

      this.international_trade_config.active_file_identification &&
        conf.push({
          file_attr: "file_identification",
          file_type: 24,
          model: this.international_trade_config.file_identification,
          label: this.international_trade_config.name_file_identification,
        });

      this.international_trade_config.active_file_doctor_cv &&
        conf.push({
          file_attr: "file_doctor_cv",
          file_type: 25,
          model: this.international_trade_config.file_doctor_cv,
          label: this.international_trade_config.name_file_doctor_cv,
        });

      return conf;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        importmedicinesform_files: {
          browse_text: "Upload file",
          download_file_link: "Review document",
          remove_file: "Remove file",
        },
      },
    },
  },
  mounted: function() {
    this.$store.commit(
      "drugtransaction/MUTATE_CLEAR_IMPORTATION_UPLOADED_FILES"
    );
    this.$store.commit(
      "drugtransaction/MUTATE_IMPORTATION_UPLOADED_FILES",
      this.documentation.documents
    );
  },
  methods: {
    ...mapActions({
      SEND_IMPORTATION_CART_DOCUMENT:
        "drugtransaction/SEND_IMPORTATION_CART_DOCUMENT",
      DELETE_IMPORTATION_CART_DOCUMENT:
        "drugtransaction/DELETE_IMPORTATION_CART_DOCUMENT",
    }),
    deleteDocument(document_uuid) {
      this.DELETE_IMPORTATION_CART_DOCUMENT({ document_uuid: document_uuid });
    },
    onFileInput(file, file_attr) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("file_original_filename", file.name);
      formData.append("documentation", this.documentation.uuid);
      formData.append("file_type", this.file_type[file_attr]);
      this.SEND_IMPORTATION_CART_DOCUMENT({
        onUploadProgress: function(progressEvent) {
          this.upload_progress[file_attr] = parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        }.bind(this),
        data: formData,
      }).then(
        res => {
          this.upload_progress[file_attr] = -1;
          this.$store.commit(
            "drugtransaction/MUTATE_IMPORTATION_UPLOADED_FILES",
            [res.data]
          );
        },
        () => {
          this.upload_progress[file_attr] = -1;
        }
      );
    },
    validateAllUploaded() {
      var valid = true;
      var form_state = {};
      for (const file_attr in this.form_state) {
        // si este archivo no está activo, no lo validamos
        let active_attr = "active_" + file_attr;
        if (!this.international_trade_config[active_attr]) {
          continue;
        }

        if (this.uploadedFilesByFileAttr[file_attr]) {
          form_state[file_attr] = true;
        } else {
          form_state[file_attr] = false;
          valid = false;
        }
      }
      this.form_state = Object.assign({}, form_state);
      return valid;
    },
  },
};
</script>

<style lang="scss" scoped>
.download-icon {
  color: $corp-color1;
  border: 2px solid $corp-color1;
  width: $input-height;
  height: $input-height;
  border-radius: $input-border-radius;
  padding: 0.4rem;
}
</style>
